import type { SalariesReportFeedback } from '#/modules/salary/types/SalariesReportFeedback';
import { postJson } from '#/utils/http/postJson';

export function salaryApiSubmitReportFeedback({
  rating,
  selectedSynonymId,
  city,
  stateCode,
  latitude,
  longitude,
  yearsOfExperience,
}: SalariesReportFeedback) {
  return postJson('/data/salary-surveys/rate-calculator', {
    rating,
    selectedSynonymId,
    city,
    stateCode,
    latitude,
    longitude,
    yearsOfExperience,
  });
}
